import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { getHandballIncidentDetailsFillState } from '../utils'
import {
  groups,
  pitchDistanceAttributeMap,
  pitchPositionAttributeMap,
} from './consts'

export function getIncidentDetailsFillState(incident: ProbableIncident): {
  state: IncidentDetailsFillState
} {
  return getHandballIncidentDetailsFillState(incident, {
    groups,
    pitchPositionAttributeMap,
    pitchDistanceAttributeMap,
    checkAssistant: true,
  })
}
